import { FridgeData } from '@gozoki/api';
import { FRIDGE_TYPES } from '@gozoki/api-types';
import { GridColDef } from '@mui/x-data-grid';
import { useEffect, useMemo } from 'react';
import SimpleDataGrid from '../../components/containers/SimpleDataGrid';

interface FridgeGridRow {
    id: number;
    reference: string | null;
    label: string;
    type: string;
    description: string;
    storeLabel: string;
}

const fridgeColumnDef = (): GridColDef[] => {
    const gridColumns: GridColDef[] = [
        {
            field: 'reference',
            headerName: 'Référence',
            width: 180,
            valueFormatter: (params) => {
                if (!params.value || params.value === '') return '-';
                return params.value;
            },
        },
        {
            field: 'label',
            headerName: 'Libellé',
            width: 250,
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 180,
            valueFormatter: (params) => {
                if (params.value === FRIDGE_TYPES.FRIDGE) {
                    return 'Réfrigérateur';
                }
                if (params.value === FRIDGE_TYPES.COLD_ROOM) {
                    return 'Chambre froide';
                }
                return params.value;
            },
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 300,
            valueFormatter: (params) => {
                if (!params.value || params.value === '') return '-';
                return params.value;
            },
        },
        {
            field: 'storeLabel',
            headerName: 'Boutique',
            width: 250,
            valueFormatter: (params) => {
                if (!params.value || params.value === '') return '-';
                return params.value;
            },
        },
    ];
    return gridColumns;
};

interface FridgeGridProps {
    data?: FridgeData[];
    loading?: boolean;
    onSelectionChange?: (selectedIds: number[]) => void;
    onPageChange?: (pageFridgeIds: number[]) => void;
}

const FridgeGrid = ({
    data = [],
    loading = false,
    onSelectionChange,
    onPageChange,
}: FridgeGridProps) => {
    // Transform the API data to match the grid structure
    const rows: FridgeGridRow[] = data.map((fridge) => ({
        id: fridge.id,
        reference: fridge.reference || null,
        label: fridge.label,
        type: fridge.type,
        description: fridge.description || '',
        storeLabel: fridge.store?.label || '',
    }));

    // Get current page fridge IDs
    const currentPageFridgeIds = useMemo(() => rows.map((row) => row.id), [rows]);

    // Notify parent of current page fridge IDs
    useEffect(() => {
        if (onPageChange) {
            onPageChange(currentPageFridgeIds);
        }
    }, [currentPageFridgeIds, onPageChange]);

    return (
        <SimpleDataGrid
            columns={fridgeColumnDef()}
            rows={rows}
            loading={loading}
            disableRowSelectionOnClick
            checkboxSelection
            onRowSelectionModelChange={(selection) => {
                if (onSelectionChange) {
                    onSelectionChange(selection as number[]);
                }
            }}
        />
    );
};

export default FridgeGrid;
